import Text from '@/components/basic/text';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
// import globalStore from '@/services/global.state';
import theme from '@/style';
import {BasicObject} from '@/types';
import {downloadApk, stopBeforeDownload} from '@/utils';
import React, {useMemo} from 'react';
import {View, Image} from 'react-native';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import {inApp, inGameBox, isPWA} from '@/utils/interface';
import {useTranslation} from 'react-i18next';
const onClickDownloadBtn = () => {
  if (stopBeforeDownload()) {
    return;
  }
  downloadApk();
};

const TextOpacity = 0.7;
const DownloadBanner = () => {
  const {calcActualSize} = useScreenSize();
  const [hide, setHide] = React.useState(false);
  const {t, i18n} = useTranslation();
  const downloadImage = useMemo(() => {
    return i18n.language === 'bn_BD'
      ? require('@/assets/imgs/home/download-bn_BD.webp')
      : require('@/assets/imgs/home/download.webp');
  }, [i18n.language]);
  const _isPWA = useMemo(() => isPWA(), []);

  if (inApp || inGameBox || _isPWA) {
    return <View />;
  }
  return hide ? (
    <View />
  ) : (
    <View
      style={[
        theme.fill.fillW,
        theme.padding.tbxxs,
        theme.padding.lrl,
        theme.flex.row,
        theme.position.rel,
        theme.flex.between,
        {
          background: 'linear-gradient(91deg, #81430A 0%, #A2751D 100%)',
          zIndex: 1,
        } as BasicObject,
      ]}>
      <View style={[theme.flex.row, theme.position.rel, theme.padding.tbxxs]}>
        <Image
          source={require('@assets/imgs/home/logo.webp')}
          // eslint-disable-next-line react-native/no-inline-styles
          style={{
            height: 40,
            width: 40,
            borderRadius: theme.borderRadiusSize.m,
          }}
        />
        <View style={[theme.flex.col, theme.flex.around, theme.margin.lefts]}>
          <Text blod size="medium" color={theme.basicColor.white}>
            SPINBAJI APP
          </Text>
          <Text
            color={theme.basicColor.white}
            style={{
              opacity: TextOpacity,
            }}>
            {t('home.label.experience')}
          </Text>
        </View>
      </View>
      <View
        style={[
          theme.flex.flex,
          theme.flex.row,
          theme.flex.centerByCol,
          {
            gap: calcActualSize(12),
          },
        ]}>
        <NativeTouchableOpacity onPress={onClickDownloadBtn}>
          <Image
            source={downloadImage}
            style={
              // eslint-disable-next-line react-native/no-inline-styles
              {
                width: 104,
                height: 36,
              }
            }
          />
        </NativeTouchableOpacity>
        <NativeTouchableOpacity
          onPress={() => setHide(true)}
          style={[theme.flex.center]}>
          <Image
            style={theme.icon.m}
            source={require('@components/assets/icons/close.webp')}
          />
        </NativeTouchableOpacity>
      </View>
    </View>
  );
};

export default DownloadBanner;
